import { useGetQuery } from "@src/appV2/api";
import { environmentConfig } from "@src/appV2/environment";
import { APP_V2_APP_EVENTS } from "@src/appV2/lib";
import { uniq } from "lodash";
import { z } from "zod";

const countiesResponseSchema = z.object({
  counties: z.array(
    z.object({
      name: z.string(),
      state: z.string(),
    })
  ),
});

export function useGetCounties() {
  return useGetQuery({
    url: `${environmentConfig.REACT_APP_BASE_API_URL}/facilities/counties`,
    responseSchema: countiesResponseSchema,
    meta: {
      logErrorMessage: APP_V2_APP_EVENTS.GET_COUNTIES_FAILURE,
    },
    select: (data) => uniq(data.counties.map((county) => county.name)),
  });
}
